module.exports = __webpack_public_path__ + "img/flag_netherlands.6e0a056a.svg";